export enum SubmissionState {
    Approved = 'Approved',
    Rejected = 'Rejected',
    Requested = 'Requested',
    UpdateRequired = 'Update Required'
}